import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../reducers";
import { bindActionCreators } from "redux";
import * as action from '../actions/health';

import { PacketGraphType, SensorData, EntityHealth, DPacket } from "../../components/Health/types";

export const useHealthState = () => {
  const summaryData = useSelector((state: RootState) => state.health.summary);
  const sensorsData = useSelector((state: RootState) => state.health.sensors) as SensorData[];
  const packetGraphData = useSelector((state: RootState) => state.health.packetGraph) as PacketGraphType[];
  const entityData = useSelector((state:RootState) => state.health.entity) as EntityHealth[];
  const dPacketsData = useSelector((state: RootState)=> state.health.dPackets) as DPacket[];
  return {
    summaryData,
    sensorsData,
    packetGraphData,
    entityData,
    dPacketsData
  };
};



// const mapDispatchToProps = (dispatch, ownProps) => {
//   return {
//     getMonitorData(ip, withLoader) {
//       dispatch(getSummaryHealthData(ip, withLoader));
//     },
//     getSensorsData(ip, withLoader) {
//       dispatch(getSensorsHealthData(ip, withLoader));
//     },
//     getPacketGraph(ip, withLoader) {
//       dispatch(getPacketGraph(ip, withLoader));
//     },
//     noData() {
//       dispatch(changeMessageNoData());
//     }
//   };
// };

export const useHealthDispatch = () => {
  const dispatch = useDispatch();
  return { ...bindActionCreators({ ...action }, dispatch) };
  // const { match } = useRouter();
  // const dispatch = useDispatch();
  // return {
  //   ...bindActionCreators({ ...action }, dispatch),
  //   loadGames: () => {
  //     const { id } = match.params as Match; //for team view id is teamId
  //     dispatch(action.getGames(id));
  //   }
  //  };
};
